import { Injectable } from '@angular/core';
import {
  ServiceGroup,
  Type,
  WorkorderDeclinedMpviCode,
  WorkOrderCase,
  WorkOrderLabour,
  WorkOrderRequestSub,
  WorkOrder } from '@quorum/models/xs-resource';

import { Actions, createEffect } from '@ngrx/effects';
import { DataPersistence } from '@nrwl/angular';
import { ApiService } from '@quorum/api';
import * as fromWorkOrders from './work-orders.actions';
import { WorkOrdersState } from './work-orders.interfaces';
// eslint-disable-next-line max-len

import { map, switchMap } from 'rxjs/operators';

@Injectable()
export class WorkOrdersEffects {
  
  getWorkOrdersFromServer = createEffect(() => this.dataPersistence.fetch(fromWorkOrders.GET_WORK_ORDERS_FROM_SERVER, {
    run: (action: fromWorkOrders.GetWorkOrdersFromServer, state: WorkOrdersState) => {
      return this.apiService
        .get<WorkOrder[]>(`v/1/fixed-operations/work-orders`, { params: action.payload })
        .pipe(map(workOrders => new fromWorkOrders.GetWorkOrdersFromServerSuccess({ workOrders: workOrders })));
    },
    onError: (action: fromWorkOrders.GetWorkOrdersFromServer, error) => {
      console.error('Error', error);
    }
  }));

  
  getWorkOrderFromServer = createEffect(() => this.dataPersistence.fetch(fromWorkOrders.GET_WORK_ORDER_FROM_SERVER, {
    run: (action: fromWorkOrders.GetWorkOrderFromServer, state: WorkOrdersState) => {
      return this.apiService
        .get<WorkOrder>(`v/1/fixed-operations/work-orders/` + action.payload.id, { params: action.payload.query })
        .pipe(map(workOrder => new fromWorkOrders.GetWorkOrderFromServerSuccess({ workOrder: workOrder })));
    },
    onError: (action: fromWorkOrders.GetWorkOrderFromServer, error) => {
      console.error('Error', error);
    }
  }));

  
  declineServiceOnWorkorder = createEffect(() => this.dataPersistence.fetch(fromWorkOrders.POST_DECLINED_SERVICE_TO_WORKORDER_TO_SERVER, {
    run: (action: fromWorkOrders.PostDeclinedServiceToWorkOrderToServer, state: WorkOrdersState) => {
      return this.apiService
        .post<WorkorderDeclinedMpviCode>(
          `v/1/fixed-operations/work-order-declined-mpvi-codes`,
          action.payload.declinedMpviCode
        )
        .pipe(
          map(
            declinedCode =>
              new fromWorkOrders.PostDeclinedServiceToWorkOrderToServerSuccess({ declinedMpviCode: declinedCode })
          )
        );
    },
    onError: (action: fromWorkOrders.PostDeclinedServiceToWorkOrderToServer, error) => {
      console.error('Error', error);
    }
  }));

  
  createWorkOrderCase = createEffect(() => this.dataPersistence.pessimisticUpdate(fromWorkOrders.POST_WORK_ORDER_CASE_TO_SERVER, {
    run: (action: fromWorkOrders.PostWorkOrderCaseToServer, state: any) => {
      return this.apiService
        .post<WorkOrderCase>(
          `v/1/fixed-operations/work-orders/${action.payload.case.workOrderId}/cases`,
          action.payload.case
        )
        .pipe(
          switchMap(workOrderCase => {
            let workOrderRequestSub = new WorkOrderRequestSub();
            workOrderRequestSub.workOrderId = workOrderCase.workOrderId;
            if (action.payload.case.warrantySubmissionTypeId == 'WC') {
              workOrderRequestSub.submitFlag = '1';
            } else {
              workOrderRequestSub.submitFlag = '0';
            }
            workOrderRequestSub.warrantySubmissionTypeId = workOrderCase.serviceGroupId;
            workOrderRequestSub.workOrderSequence = workOrderCase.sequence;
            workOrderRequestSub.warrantySubmissionTypeId = workOrderCase.warrantySubmissionTypeId;
            workOrderRequestSub.labourCode = workOrderCase.labourOp;
            return this.apiService
              .post<WorkOrderRequestSub>(
                `v/1/fixed-operations/work-orders/${action.payload.case.workOrderId}/request-subs`,
                workOrderRequestSub
              )
              .pipe(
                switchMap(workOrderRequestSub => {
                  return this.apiService.get<Type>(`v/1/vehicles/vehicle-types/${action.payload.vehicle.typeId}`).pipe(
                    switchMap((vehType: Type) => {
                      return this.apiService
                        .get<WorkOrderRequestSub>(
                          `v/1/fixed-operations/work-orders/${action.payload.case.workOrderId}/workflow/labourRate`,
                          {
                            params: {
                              vehicleClassId: vehType.classId,
                              rooftopId: action.payload.vehicle.rooftopId,
                              defaultFlag: 1,
                              windowTypeId: 'L'
                            }
                          }
                        )
                        .pipe(
                          switchMap(labourRate => {
                            let workOrderLabour = new WorkOrderLabour();

                            let serviceGroup =
                              state.labourOperations.serviceGroups.entities[workOrderCase.serviceGroupId];

                            let serviceGroupRate =
                              state.labourOperations.rates.entities[serviceGroup.serviceGroupRateId];
                            if (serviceGroupRate == null) {
                              serviceGroupRate = {};
                            }
                            workOrderLabour.warrantyTypeId = 'L';
                            workOrderLabour.workOrderId = workOrderCase.workOrderId;
                            workOrderLabour.caseFromQuote = false;
                            workOrderLabour.caseStatusId = 'N';
                            workOrderLabour.chargeoutRateBasisId = 1;
                            workOrderLabour.creditMemo = '0';
                            workOrderLabour.estimatedTime = workOrderCase.estimatedTime
                              ? workOrderCase.estimatedTime
                              : null;
                            workOrderLabour.initialLabourRate = serviceGroupRate.rate ? serviceGroupRate.rate : null;
                            workOrderLabour.labourOp = workOrderCase.labourOp;
                            workOrderLabour.quoteFlag =
                              state.fixedOperations.workOrders.entities[workOrderCase.workOrderId].statusId === 'Q'
                                ? '1'
                                : '0';
                            workOrderLabour.rate = serviceGroupRate.labourRate ? serviceGroupRate.labourRate : null;
                            workOrderLabour.rateTypeId = serviceGroupRate.rateType ? serviceGroupRate.rateType : null;
                            workOrderLabour.recommendedHours = workOrderCase.recommendedHours
                              ? workOrderCase.recommendedHours
                              : null;
                            workOrderLabour.serviceGroupId = workOrderCase.serviceGroupId;
                            workOrderLabour.serviceName = workOrderCase.note;
                            // eslint-disable-next-line max-len
                            workOrderLabour.shopSupplyFlag = '1'; //Get asscu_shop_flag if 0 then 0. If 1 then we check sgred_shop_flag if null/''/'1' we use '1' ELSE '0'
                            // eslint-disable-next-line max-len
                            if (action.payload.case.warrantySubmissionTypeId == 'WC') {
                              workOrderLabour.submitFlag = '1';
                            } else {
                              workOrderLabour.submitFlag = '0';
                            }

                            workOrderLabour.technicianRateBasisId = 1;
                            workOrderLabour.warrantyCase = workOrderRequestSub.warrantyCase;
                            //workOrderLabour.sequence = workOrderCase.sequence;

                            switch (action.payload.vehicle.typeId) {
                              case 'C':
                                workOrderLabour.subTransactionTypeId = serviceGroupRate.retailLabourCarTransTypeId
                                  ? serviceGroupRate.retailLabourCarTransTypeId
                                  : null;

                                break;
                              case 'M':
                                workOrderLabour.subTransactionTypeId = serviceGroupRate.retailLabourMediumDutyTruckTransTypeId
                                  ? serviceGroupRate.retailLabourMediumDutyTruckTransTypeId
                                  : null;
                                break;
                              case 'L':
                                workOrderLabour.subTransactionTypeId = serviceGroupRate.retailLabourTruckTransTypeId
                                  ? serviceGroupRate.retailLabourTruckTransTypeId
                                  : null;
                                break;
                              default:
                                workOrderLabour.subTransactionTypeId = null;
                                break;
                            }

                            if (workOrderLabour.subTransactionTypeId == null) {
                              workOrderLabour.subTransactionTypeId = labourRate.labourTransType;
                            }
                            //workOrderLabour.subTransactionTypeId = serviceGroup.

                            switch (workOrderCase.warrantySubmissionTypeId) {
                              case 'WC':
                              case 'EC':
                              case 'CC':
                              case 'TC':
                              case 'MM':
                              case 'SN':
                              case 'DP':
                              case 'MS':
                              case 'TW':
                              case 'W2':
                              case 'E2':
                              case 'C2':
                                workOrderLabour.warrantyTypeId = 'L';
                              default:
                                workOrderLabour.warrantyTypeId = null;
                            }
                            workOrderLabour.warrantySubmissionTypeId = workOrderCase.warrantySubmissionTypeId;

                            return this.apiService
                              .post<WorkOrderLabour>(
                                `v/1/fixed-operations/work-orders/${action.payload.case.workOrderId}/labours`,
                                workOrderLabour
                              )
                              .pipe(
                                map(workOrderLabour => {
                                  return new fromWorkOrders.PostWorkOrderCaseToServerSuccess({ case: workOrderCase });
                                })
                              );
                          })
                        );
                    })
                  );
                })
              );
          })
        );
    },
    onError: (action: fromWorkOrders.PostWorkOrderCaseToServer, error) => {
      console.error('Error', error);
    }
  }));

  constructor(
    private actions: Actions,
    private dataPersistence: DataPersistence<WorkOrdersState>,
    private apiService: ApiService
  ) {}
}
